module.exports = __webpack_public_path__ + "static-portal/img/new4-3.77569c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new4-3.png
// module id = nAJo
// module chunks = 4